import * as React from 'react'
import { Controller } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import SelectContact from '../../../../components/common/SelectContact/SelectContact.tsx'
import PetSelect from '../../../../components/common/SelectPet/PetSelect.tsx'
import { sendCommand } from '../../../../helpers/commandHelper.ts'
import { controlState } from '../../../../store/controlState.ts'
import { useSnapshot } from 'valtio'
import { dataState } from '../../../../store/dataState.ts'
import { Section } from '../../components/Section.tsx'

interface Props {
    control: any
    disabled: boolean
    data: any
    watch: any
    setValue: (n: any, v: any) => void
    petCreated: boolean
    STEPS: any
    createAccount?: boolean
}

export const ChoosePetAndContact: React.FC<Props> = (props) => {
    const { disabled, data, control, watch, petCreated, STEPS, createAccount } = props

    const navigate = useNavigate()

    const petId = watch('petId')
    const pets = (useSnapshot(dataState) as typeof dataState).pets
    const contactId = watch('contactId')
    const contacts = (useSnapshot(dataState) as typeof dataState).contacts

    React.useEffect(() => {
        const assignPet = async (petId: string) => {
            const resultData = await sendCommand('assign', data.iccid, petId)
            if (resultData) {
                dataState.devices = (resultData)
                const petName = pets.find(p => p._id === petId)?.petName
                toast.success(`Gibi Tracker assigned to ${petName}`)
            } else {
                toast.error('Error, Gibi Tracker assignment failed, try again later.')
            }
        }
        if (petId) {
            if (petId === 'new') {
                controlState.currentPage = 'registration'
                const state = { data: data }
                navigate('/pets', { state })
            } else {
                void assignPet(petId)
            }
        }

    }, [petId])

    React.useEffect(() => {
        const followPet = async (contactId: string) => {
            const resultData = await sendCommand('follow', data.iccid, contactId)
            if (resultData) {
                dataState.contacts = (resultData)
                const petName = pets.find(p => p._id === petId)?.petName
                const c = contacts.find(c => c._id === contactId)
                toast.success(`${c?.firstName} ${c?.lastName} following ${petName}`)
            } else {
                toast.error('Error, follow pet failed, try again later.')
            }
        }

        if (contactId) {
            if (contactId === 'new') {
                controlState.currentPage = 'registration'
                const state = { data: data }
                navigate('/contactForm', { state })
            } else {
                void followPet(contactId)
            }
        }

    }, [contactId])

    const title = createAccount ? 'Add your pet and contacts' : 'Assign a pet and contacts'

    return (
        <Section disabled={disabled} title={title} step={STEPS.pet}>

            {!disabled ? <div>
                <Controller
                    name={'petId'}
                    render={({ field }) =>
                        <Section title={'Assign a pet'} disabled={!!petId}>
                            <PetSelect
                                onChange={function (p: {
                                    label: string,
                                    value: string
                                }): void {
                                    field.onChange(p.value)
                                }}
                                value={petId}
                                onlyShowInactive
                                disabled={!!petId}
                                displayOnly={petCreated}
                            />
                        </Section>
                    }
                    control={control}
                />

                <div className={'pt-4'}>
                    <Controller
                        name={'contactId'}
                        render={({ field }) =>
                            <Section title={'Assign a contact'} disabled={!petId}>
                                <SelectContact
                                    onChange={function (p: {
                                        label: string,
                                        value: string
                                    }): void {
                                        field.onChange(p.value)
                                    }}
                                    value={contactId}
                                    petId={petId}
                                    disabled={!petId}
                                    listFollowers={true}
                                />
                            </Section>
                        }
                        control={control}
                    />
                </div>
            </div> : null}

        </Section>
    )
}
